import { create } from 'zustand';

// ── Store ────────────────────────────────────────────────────────────

interface LayoutState {
  searchOpen: boolean;

  openSearch: () => void;
  closeSearch: () => void;
  toggleSearch: () => void;
}

export const useLayoutStore = create<LayoutState>((set, get) => ({
  searchOpen: false,

  openSearch: () => set({ searchOpen: true }),
  closeSearch: () => set({ searchOpen: false }),
  toggleSearch: () => set({ searchOpen: !get().searchOpen }),
}));
